module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dashboard"
  }, [_c('div', {
    staticClass: "page-bar hide"
  }, [_c('ul', {
    staticClass: "page-breadcrumb"
  }, [_c('li', [_c('i', {
    staticClass: "icon-home"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/workspace/"
    }
  }, [_vm._v("Workspace")]), _vm._v(" "), _c('i', {
    staticClass: "fa fa-angle-right"
  })], 1), _vm._v(" "), _vm._m(0)]), _vm._v(" "), _vm._m(1)]), _vm._v(" "), _c('breadcrumb-bar', {
    attrs: {
      "crumbs": ['Shared files']
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "portlet light"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "portlet-body"
  }, [(_vm.user.access >= 4) ? [_c('div', {
    staticClass: "upload"
  }, [_c('button', {
    staticClass: "btn green upload-button"
  }, [_vm._v("Add Files")]), _vm._v(" "), _c('input', {
    ref: "files",
    attrs: {
      "type": "file",
      "id": "file",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        return _vm.handleFilesUpload()
      }
    }
  })]), _vm._v(" "), _c('button', {
    staticClass: "btn green mt-ladda-btn ladda-button",
    attrs: {
      "id": "start-upload",
      "data-style": "expand-left",
      "disabled": this.fileList == ''
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.submitFiles()
      }
    }
  }, [_c('span', {
    staticClass: "ladda-label"
  }, [_vm._v("Upload Files")])])] : _vm._e(), _vm._v(" "), (this.fileList != '') ? _c('div', [_c('span', [_c('strong', [_vm._v("Files: ")]), _vm._v(_vm._s(_vm.fileList))])]) : _vm._e(), _vm._v(" "), (_vm.totalRecords > 0 || _vm.serverParams.columnFilters != {}) ? _c('div', {
    staticClass: "files-table"
  }, [_c('vue-good-table', {
    attrs: {
      "columns": _vm.columns,
      "rows": _vm.sharedFiles,
      "pagination-options": {
        enabled: true,
        perPageDropdown: [10, 20, 50, 100, 200, 500],
        dropdownAllowAll: true,
        perPage: this.serverParams.perPage
      },
      "mode": "remote",
      "totalRows": _vm.totalRecords,
      "isLoading": _vm.isLoading
    },
    on: {
      "on-page-change": _vm.onPageChange,
      "on-sort-change": _vm.onSortChange,
      "on-column-filter": _vm.onColumnFilter,
      "on-per-page-change": _vm.onPerPageChange
    },
    scopedSlots: _vm._u([{
      key: "table-row",
      fn: function(props) {
        return [(props.column.field == 'deleted') ? _c('span', [_vm._v(_vm._s(props.row.deleted ? 'Deleted' : 'Published'))]) : (props.column.field == 'date_attached') ? _c('span', [_vm._v(_vm._s(_vm._f("formatDateModalNoTimeZone")(props.row.date_attached.date)) + " ")]) : (props.column.field == 'actions') ? _c('div', {
          staticClass: "last-dropdown"
        }, [_c('actions-menu', [(_vm.user.access >= 3) ? _c('actions-menu-item', {
          attrs: {
            "title": "Download",
            "icon": "fa-download",
            "href": _vm.getFileUrl(props.row.id)
          }
        }) : _vm._e(), _vm._v(" "), (_vm.user.access >= 4) ? _c('actions-menu-item', {
          attrs: {
            "title": "Edit description",
            "icon": "fa-pencil-square-o"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.editDescription(props.row.description, props.row.id)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.user.access >= 4 && props.row.deleted) ? _c('actions-menu-item', {
          attrs: {
            "title": "Restore",
            "icon": "fa-upload"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.restore(props.row.id)
            }
          }
        }) : _vm._e(), _vm._v(" "), (_vm.user.access >= 4 && !props.row.deleted) ? _c('actions-menu-item', {
          attrs: {
            "title": "Delete",
            "icon": "fa-trash"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.deleteFileModal(props.row.id)
            }
          }
        }) : _vm._e()], 1)], 1) : _c('span', [_vm._v(_vm._s(props.formattedRow[props.column.field]))])]
      }
    }], null, false, 3756740321)
  }, [_vm._v(" "), _c('template', {
    slot: "loadingContent"
  }, [_c('vue-spinner')], 1)], 2)], 1) : _c('div', {
    staticClass: "not-found-results"
  }, [_c('h4', [_vm._v("File list is empty.")])]), _vm._v(" "), (_vm.serverParams.showDeleted && _vm.user.access >= 4) ? _c('button', {
    staticClass: "btn default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.hideDeleted()
      }
    }
  }, [_vm._v("Hide Deleted Files")]) : (_vm.user.access >= 4) ? _c('button', {
    staticClass: "btn default",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.showDeleted()
      }
    }
  }, [_vm._v("Show Deleted Files")]) : _vm._e()], 2)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "edit-description-modal",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.updatingDescription) ? _c('vue-spinner') : _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "shared-file-description"
    }
  }, [_vm._v("Description")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newDescription),
      expression: "newDescription"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "id": "shared-file-description",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.newDescription)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.newDescription = $event.target.value
      }
    }
  })])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.saveDescription()
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('button', {
    staticClass: "btn default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("Cancel")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "delete-file-modal",
      "role": "dialog",
      "aria-hidden": "true"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-sm"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [(_vm.deletingFile) ? _c('vue-spinner') : _c('span', [_vm._v("Are you sure you want to delete file: "), _c('br'), _c('strong', [_vm._v(_vm._s(_vm.selectedFile !== undefined ? _vm.selectedFile.original_filename : ''))])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn green",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.deleteFile()
      }
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('button', {
    staticClass: "btn default",
    attrs: {
      "data-dismiss": "modal"
    }
  }, [_vm._v("No")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('span', [_vm._v("Shared files")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-toolbar hide"
  }, [_c('div', {
    staticClass: "btn-group pull-right"
  }, [_c('button', {
    staticClass: "btn btn-fit-height grey-salt dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown",
      "data-hover": "dropdown",
      "data-delay": "1000",
      "data-close-others": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v(" Widgets\n          "), _c('i', {
    staticClass: "fa fa-angle-down"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu pull-right module-zone",
    attrs: {
      "role": "menu"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption caption-md"
  }, [_c('span', {
    staticClass: "caption-subject bold uppercase"
  }, [_vm._v("Shared files")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Edit description")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Delete file")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-33a1393d","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/SharedFiles.vue
// module id = 1602
// module chunks = 1